.is-invalid {
  border-color: #dc3545;
}

.is-valid {
  border-color: #198754;
}